import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		// APP信息
		appInfo: sessionStorage.getItem("appInfo") ? JSON.parse(sessionStorage.getItem("appInfo")) : {
			title: '', // 名称
			appAbbreviation:'',
			appLogoUrl: '', // app logo
			download: { // 下载/h5链接
				android: '',
				ios: ''
			},
			version: '',
			releaseTime: ''
		}
	},
	mutations: {
		changeAppInfo(state, payload) {
			state.appInfo = payload.appInfo;
		}
	},
	actions: {},
	modules: {}
});
